import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { GoToCheckout } from '@features/go-to-checkout'

import { useZonesFromAddress } from '@shared/hooks/useZonesFromAddress'
import Button from '@shared/ui/button'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'

interface CartBottomBarProps {
  total: number;
}

export default function CartBottomBar (props: CartBottomBarProps) {
  const { total } = props
  const isMobile = useMediaQuery('(max-width: 1179px)')
  const { t: tc } = useTranslation('cart')

  const { minOrderCost, isPickup } = useZonesFromAddress()

  if (!isMobile) return null

  return (
    <motion.div
      className={styles.root}
      initial={{ y: '100%', opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: '100%', opacity: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <div className={styles.totalBox}>
        <span className={styles.label}>{tc('total.total')}:</span>
        <span className={styles.value}>{formatPrice(total)}</span>
      </div>
      {!isPickup() && total < minOrderCost ? (
        <Button
          className={styles.button}
          disabled={!isPickup() && total < minOrderCost}
          size="large"
        >
          {tc('preview.min_order_message', {
            minOrderCost: formatPrice(minOrderCost),
            amount: formatPrice(minOrderCost - total),
          })}
        </Button>
      ) : (
        <GoToCheckout />
      )}
    </motion.div>
  )
}
